import RegularPagesLayout from "../components/layout/RegularPagesLayout";
import { fetchPage } from "../services/useFetch";
import { pageFilter } from "../services/cms/pages";
import GeneralPages from "../components/page-components/general/GeneralPages";
import parse from "html-react-parser";

const Terms = ({ pageData, conditions }) => {
  return (
    <div className="container">
      <div className="wrapper-90">
        <div className="general-wrapper">
          <h1>Terms of Service</h1>
          <div>{parse(conditions?.terms_conditions)}</div>
        </div>
      </div>
    </div>
  );
};

export async function getServerSideProps({ req }) {
  const { cookies } = req;

  const pageStatus = await fetchPage("pages.GeneralPage");

  let pageData;
  if (pageStatus.status === 200) {
    const pageTemp = await pageStatus.json();
    pageData = await pageFilter(pageTemp, "terms");
  }

  const userStatus = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/user/dashboard`,
    {
      credentials: "include",
      headers: {
        Cookie: `boho_session=${cookies.boho_session}`,
      },
    },
  );
  const terms = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/faq/getBody`,
     // 'http://localhost:3000/api/faq/getBody',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    );
  let conditions;
  if (terms.status === 200) {
    conditions = await terms.json();
  }

  if (userStatus.status === 200) {
    return {
      redirect: {
        permanent: false,
        destination: "/dashboard",
      },
      props: {},
    };
  }

  return {
    props: {
      // testing: null,
      pageData: pageData[0] || null,
      conditions: conditions || null,
    },
  };
}

Terms.getLayout = function getLayout(page) {
  return <RegularPagesLayout>{page}</RegularPagesLayout>;
};

export default Terms;
